import React, { Component } from "react";
import { FiChevronUp } from "react-icons/fi";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
} from 'react-accessible-accordion';
import { Link } from 'react-router-dom';

import PageHelmet from "../../component/common/Helmet";
import Breadcrumb from "../../elements/common/Breadcrumb";
import ScrollToTop from 'react-scroll-up';
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";

class FAQs extends Component{
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='FAQs' />

                 {/* Start Header Area  */}
                <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black"/>
                {/* End Header Area  */}
                
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'FAQs'}   />
                {/* End Breadcrump Area */}


                {/* Start Faq Area */}
                    <div className="pv-feaq-area bg_color--3 ptb--120">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 offset-lg-2">
                                    <div className="section-title text-left pb--30">
                                        <p>Check out our FAQ section to see if we can help.</p>
                                        <h2 className="theme-gradient">Frequently asked questions</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-8 offset-lg-2">
                                    <div className="faq-area">
                                        <Accordion className="accodion-style--1" preExpanded={'0'}>
                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                        What is EEVS Alumni?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>EEVS Alumni is a vibrant community with more than 40,000 members from all
                                                        over the world. And Expert Alumni are clients who have used our services in the
                                                        past. Being a member of Expert Education and Visa Services you will be able to
                                                        enjoy the offers and discounts that we provide. We deeply care about our ever
                                                        growing community and wish to keep us connected throughout the years.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>

                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                        How do I become a member?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p><Link to="/join-now">Click here</Link> and become a member of EEVS Alumni.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>

                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                        Why should I join EEVS Alumni?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>By becoming a member you will open doors to offers, discounts that will help you
                                                        take out services not only from EEVS offices but from our partners as well. We
                                                        will provide you with offers that you won’t be able to resist. As our offer is
                                                        limited to our Alumni members only you should definitely join.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>

                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                        What to expect right after joining the alumni?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>Right after becoming a member you will receive an email to welcome you to our
                                                    ever-growing commuity, along with the list of benefits that you will receive now
                                                    that you&#39;re a member.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>


                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                    Where can I use my points received as an alumni member?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>You can use your points to take out services in expert offices as well as receive
                                                        various offers and discounts from our partners.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>

                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                    What to do if I have problem joining as a member?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>If you have any problem regarding any process to become a member, be sure to
                                                        contact us</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>

                                            <AccordionItem >
                                                <AccordionItemHeading>
                                                    <AccordionItemButton>
                                                        Where will I be notified when I am offered deals/ discounts?
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel>
                                                    <p>We will update it on our page and you will also receive an email regarding the
deals/ discounts that you shall receive as a member of the alumni.</p>
                                                </AccordionItemPanel>
                                            </AccordionItem>
                                          
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                     {/* Start Faq Area */}
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 

            </React.Fragment>
        )
    }
}
export default FAQs;
